import { Component, OnInit, Input, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $;

@Component({
  selector: 'sw-input-tags-box',
  templateUrl: './sw-input-tags-box.component.html',
  styleUrls: ['./sw-input-tags-box.component.css']
})
export class SwInputTagsBoxComponent implements OnInit {

  constructor(private el: ElementRef,
    private box: SwMassageBoxService,) { }

  ngOnInit() {
  }

  @Input() ids:any;

  @Input() elem:any;

  @Input() dropdown: boolean = true;;

  @Input() height: string = '250px';

  datas:any=[]
  @Input() elemId:any;
  /**
   * 最多能输入的个数
   */
  @Input() maxInputNum: number = 0; 
 /**
 * 选中的id
 * @ignore
 */
@Input() selected :any= [];  

/**
 * 选中的文本
 * @ignore
 */
@Input() selectedText = []; 

/**
   * 文本框类型: text:普通文本类型； phone：手机号类型
   */
  @Input() type: string = 'text';
  /**
   * 搜索框的值
   */
  inputText: any;

  /**
   * 输出属性,点击添加'xxx'时，将要新建的数据抛出，业务方接受数据后要创建新标签且且将此新标签选中回填
   */
  @Output() addNewClick = new EventEmitter();

  @Output() closeSelect = new EventEmitter();

  ngAfterViewInit(): void {
    //如果有搜索框则给焦点
    let postion = this.elem.nativeElement.getBoundingClientRect()
    this.el.nativeElement.style.position = 'fixed';
    this.el.nativeElement.style.zIndex = 9990;
    //this.el.nativeElement.style.top = postion.bottom + 'px';
    this.el.nativeElement.style.left = postion.left + 'px';
    this.el.nativeElement.style.width = postion.width + 'px';

    let height = this.height.split('px')[0]
    let clientHeight = document.documentElement.clientHeight || document.body.clientHeight
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    let heightAndTop = clientHeight + scrollTop
    if((heightAndTop-postion.bottom)<parseInt(height) ){  //如果输入框下面没有足够的高度，就放上面
      this.el.nativeElement.style.top = postion.top - parseInt(height)  + 'px';
    }else {
      //下方有足够高度，就放下面
      this.el.nativeElement.style.top = postion.bottom + 'px';
    }
    //如果有搜索框则给焦点
    setTimeout(() => {
      // 获取input的dom元素
      var search = document.getElementById(this.ids);
      if(search){
        // 自动获取焦点
        search.focus()

      }
    }, 200)

    this.myModalBodyScroll()  //监听 myModalBody 盒子的滚动条事件
    this.myWrapContScroll()  //监听 myWrapCont 盒子的滚动条事件
  }

  ngOnDestroy(): void {
    this.myModalBodyRmScroll()  //移除 myModalBody 盒子的滚动条事件
    this.myWrapContRmScroll()  //移除 myWrapCont 盒子的滚动条事件
  }


  /**
   * 选中下拉框数据
   * @ignore
   */
  // onVoted(e, item){
  //   const action = this.isChecked(item.id)?'remove':'add';
  //   this.updateSelected(action,item);
  //   return false; //阻止事件冒泡而关闭下拉框
  // }




  close(){
    this.closeSelect.emit(false)
  }

  @HostListener('document:mousewheel', ['$event']) onmousewheel(event) {
    //鉴定全屏键盘事件 如果是回车触发
    if(this.mouseo)
        this.closeSelect.emit(false)
  } 

  // //屏幕缩放时
  // @HostListener('window:resize', ['$event']) resize(event) {
  //   /* //屏幕缩放时,下拉框消失,否则下拉框
  //   this.closeSelect.emit(false) */
  //   //屏幕缩放时,重新设置下拉框的位置及宽度
  //   let postion = this.elem.nativeElement.getBoundingClientRect()
  //   this.el.nativeElement.style.top = postion.bottom + 'px';
  //   this.el.nativeElement.style.left = postion.left + 'px';
  //   this.el.nativeElement.style.width = postion.width + 'px';
  // }

  mouseo:boolean = true;
  mouseoverEvent(){
    this.mouseo = false;
  }
  mouseoutEvent(){
    this.mouseo = true;
  }

  //监听 myWrapCont 盒子的滚动条事件,滚动就让日期控件消失
  myWrapContScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myWrapContRmScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myWrapContScroll)
    }
  }

  //监听 myModalBody 盒子的滚动条事件,滚动就让日期控件消失
  myModalBodyScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myModalBodyRmScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myModalBodyScroll)
    }
  }

  /**
   * 失去焦点
   * @ignore
   */
  Blur() {
    setTimeout(() => {
      // 销毁组件
      this.closeSelect.emit(false)
      
    }, 200);
    event.stopImmediatePropagation();
  }
//键盘enter事件
enterAdd(event){
  if(event.which == 13){
    console.log(this.inputText)
    event.stopPropagation()
    this.add()
  }
 }
  txt:any = ''
  //创建新标签
  add(){
    if(this.inputText == '' || !this.inputText){
      this.closeSelect.emit(false)
    }else {
      let isSame = this.selected.findIndex(value => value == this.inputText)
     if(isSame == -1){
       if(this.type == 'phone'){
         //判断格式是否正确
         let reg=/^1[3|4|5|6|7|8|9][0-9]{9}$/;//正则表达式
         let telephone=this.inputText;//取得输入框的值
        
         if(reg.test(telephone)){
            this.addNewClick.emit(this.inputText)
            this.closeSelect.emit(false)  //销毁组件
         }else {
          this.txt = '手机号码格式不匹配'
         }
       }else {
        this.addNewClick.emit(this.inputText)
        this.closeSelect.emit(false)  //销毁组件
       }
      
     }else {
      this.txt = '该数据已存在'
     }
    }
    

  }
 

 //监听查看示例事件
 @HostListener('document:click', ['$event'])
 public onClick(event) {
      event.stopPropagation()
      setTimeout(()=>{
        if(this.elemId){
          const clickInside = this.el.nativeElement.contains(event.target) 
          const clickInside2 = document.getElementById(this.elemId) ? document.getElementById(this.elemId).contains(event.target):false
          if(!(clickInside || clickInside2)) {
           this.closeSelect.emit(false)
          }
        }
      },20)
 }


}
